import * as React from 'react';
import { DistributionPanel } from './components/distribution-panel';
import { DistributionState } from 'app/area/reports/containers/distribution/types-store';
import { ReportCommonApi } from 'app/area/reports/types-api';
import { 
  useActionCreators, 
  useLoadDistributionDefaultFieldsEffect, 
  useWorkingDefinitionExposureState 
} from 'app/area/reports/containers/distribution/hooks';

export interface DistributionContainerProps { 
  orderNumber: string;
  translation: any;
  distributionFieldState: DistributionState;
}

export const DistributionContainerForApi = (api: ReportCommonApi) => ({
  orderNumber,
  distributionFieldState,
  translation
}: DistributionContainerProps) => {
  
  const {
    loadDistributionFields,
    updateDefaultDistributionFields,
    clearValue,
    onSelectField,
    updateSelectedField
  } = useActionCreators(api);

  const {
    selectedExposureApplication,
    selectedExposureFactor,
    selectedExposurePercent
  } = useWorkingDefinitionExposureState();

  useLoadDistributionDefaultFieldsEffect(api);

  return <DistributionPanel
    orderNumber={orderNumber}
    fetching={distributionFieldState.fetching}
    data={distributionFieldState}
    selectedExposureApplication={selectedExposureApplication}
    selectedExposureFactor={selectedExposureFactor}
    selectedExposurePercent={selectedExposurePercent}
    onLoadFields={loadDistributionFields}
    onUpdateDefaultFields={updateDefaultDistributionFields}
    onRemove={clearValue}
    onSelect={onSelectField}
    onUpdateField={updateSelectedField}
    translation={translation}
  />;
};
